import Project from 'src/entities/Project';
import * as React from 'react';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import './TeamMembers.css';
import ProjectTeamMemberCardContainer from 'src/modules/project/partials/team-members/ProjectTeamMemberCard.container';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';

interface Props {
  project: Project;
  teamMembers: ProjectTeamMember[];
  invest: boolean;
  closedProject: boolean;
}

const ProjectTeamMembersComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="col-sm-9">
    <div className="padding-left-30">
      <div className="gap-50"/>
      <h3>
        Equipo de {props.project.company.name}
      </h3>
      {props.teamMembers.map((teamMember, key) => (
        <div key={key}>
          <ProjectTeamMemberCardContainer teamMember={teamMember}/>
          <div className="gap-30"/>
        </div>
      ))}
      <div className="gap-50"/>
      <ProjectActionToolbarContainer
        project={props.project}
        invest={props.invest}
        closedProject={props.closedProject}
      />
        <div className="gap-50"/>
    </div>
  </div>
);

export default ProjectTeamMembersComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/team-members/ProjectTeamMembers.component.tsx